// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-shadow {
  /* -webkit-box-shadow: 0 1px 1px rgba(72, 78, 85, 0.6);
  box-shadow: 0 1px 1px rgba(72, 78, 85, 0.6); */
  /* box-shadow: 0 20px 40px rgba(53, 53, 54, 0.6); */
  transition: all 0.2s ease-out;
}

.box-shadow:hover {
  /* -webkit-box-shadow: 0 20px 40px rgba(72, 78, 85, 0.6); */
  /* box-shadow: 0 20px 40px rgba(72, 78, 85, 0.6); */
  /* box-shadow: 0 5px 10px rgba(53, 53, 54, 0.6); */
  /* -webkit-transform: translateY(-15px);
  -moz-transform: translateY(-15px);
  -ms-transform: translateY(-15px);
  -o-transform: translateY(-15px); */
  /* transform: translateY(-15px); */
  transform: scale(1.05);
}

/* .main-panel > .content {
  padding: 0 0 0 0 !important;
} */

.bg-dark {
  background-color: #171717 !important;
  margin-bottom: 0 !important;
  /* padding: 1rem 1rem 0 0 !important; */
  height: 40px;
}
.main-panel .content {
  transition: ease-out all 0.3s;
}

.btn-simple {
  border-color: gray !important;
  /* color: #f18f3c !important; */
}

.btn-simple {
  color: #fff !important;
}

@media only screen and (min-width: 1224px) {
  .sidebar:hover + .main-panel .content {
    padding-left: 20vw !important;
    transition: ease-out all 0.3s;
  }
}

.btn.btn-simple.active {
  background-color: gray !important;
  background-image: none !important;
  border: none !important;
}
.btn.btn-simple.active:hover {
  background-color: gray !important;
  background-image: none !important;
}

.chart-area {
  height: 100% !important;
}

/* canvas {
  height: 300px !important;
} */
.card-chart {
  height: 570px !important;
}
canvas {
  /* height: 500px !important; */
}

.dashboard-row > div {
  height: 300px !important;
}

.assetCard {
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}

.jtk-overlay {
  /* background-color: #60bfbf56 !important; */
  background-color: transparent !important;
  /* border: 0.2rem dashed #777; */
  border-radius: 35% !important;
  font-size: 0.7rem !important;
}
/* .card-chart > .card {
  height: 500px !important;
} */

/* @media only screen and (max-width: 1000px) {
  .form-control {
    color: red;
    display: block !important;
  }
  .percent {
    color: red;
    display: block !important;
  }
  .btn-group-toggle {
    color: red;
    display: block !important;
  }
} */

/* .card-title > * {
  display: block;
} */
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/custom.css"],"names":[],"mappings":"AAAA;EACE;gDAC8C;EAC9C,mDAAmD;EAKnD,6BAA6B;AAC/B;;AAEA;EACE,2DAA2D;EAC3D,mDAAmD;EACnD,kDAAkD;EAClD;;;oCAGkC;EAClC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;GAEG;AACH;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;GAEG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;;GAEG","sourcesContent":[".box-shadow {\r\n  /* -webkit-box-shadow: 0 1px 1px rgba(72, 78, 85, 0.6);\r\n  box-shadow: 0 1px 1px rgba(72, 78, 85, 0.6); */\r\n  /* box-shadow: 0 20px 40px rgba(53, 53, 54, 0.6); */\r\n  -webkit-transition: all 0.2s ease-out;\r\n  -moz-transition: all 0.2s ease-out;\r\n  -ms-transition: all 0.2s ease-out;\r\n  -o-transition: all 0.2s ease-out;\r\n  transition: all 0.2s ease-out;\r\n}\r\n\r\n.box-shadow:hover {\r\n  /* -webkit-box-shadow: 0 20px 40px rgba(72, 78, 85, 0.6); */\r\n  /* box-shadow: 0 20px 40px rgba(72, 78, 85, 0.6); */\r\n  /* box-shadow: 0 5px 10px rgba(53, 53, 54, 0.6); */\r\n  /* -webkit-transform: translateY(-15px);\r\n  -moz-transform: translateY(-15px);\r\n  -ms-transform: translateY(-15px);\r\n  -o-transform: translateY(-15px); */\r\n  /* transform: translateY(-15px); */\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* .main-panel > .content {\r\n  padding: 0 0 0 0 !important;\r\n} */\r\n\r\n.bg-dark {\r\n  background-color: #171717 !important;\r\n  margin-bottom: 0 !important;\r\n  /* padding: 1rem 1rem 0 0 !important; */\r\n  height: 40px;\r\n}\r\n.main-panel .content {\r\n  transition: ease-out all 0.3s;\r\n}\r\n\r\n.btn-simple {\r\n  border-color: gray !important;\r\n  /* color: #f18f3c !important; */\r\n}\r\n\r\n.btn-simple {\r\n  color: #fff !important;\r\n}\r\n\r\n@media only screen and (min-width: 1224px) {\r\n  .sidebar:hover + .main-panel .content {\r\n    padding-left: 20vw !important;\r\n    transition: ease-out all 0.3s;\r\n  }\r\n}\r\n\r\n.btn.btn-simple.active {\r\n  background-color: gray !important;\r\n  background-image: none !important;\r\n  border: none !important;\r\n}\r\n.btn.btn-simple.active:hover {\r\n  background-color: gray !important;\r\n  background-image: none !important;\r\n}\r\n\r\n.chart-area {\r\n  height: 100% !important;\r\n}\r\n\r\n/* canvas {\r\n  height: 300px !important;\r\n} */\r\n.card-chart {\r\n  height: 570px !important;\r\n}\r\ncanvas {\r\n  /* height: 500px !important; */\r\n}\r\n\r\n.dashboard-row > div {\r\n  height: 300px !important;\r\n}\r\n\r\n.assetCard {\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.jtk-overlay {\r\n  /* background-color: #60bfbf56 !important; */\r\n  background-color: transparent !important;\r\n  /* border: 0.2rem dashed #777; */\r\n  border-radius: 35% !important;\r\n  font-size: 0.7rem !important;\r\n}\r\n/* .card-chart > .card {\r\n  height: 500px !important;\r\n} */\r\n\r\n/* @media only screen and (max-width: 1000px) {\r\n  .form-control {\r\n    color: red;\r\n    display: block !important;\r\n  }\r\n  .percent {\r\n    color: red;\r\n    display: block !important;\r\n  }\r\n  .btn-group-toggle {\r\n    color: red;\r\n    display: block !important;\r\n  }\r\n} */\r\n\r\n/* .card-title > * {\r\n  display: block;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
